import { request } from "../utils/request.js"

export const commodityTransferOrder_exportForManage = (pojo, args) => request({
    url: 'commodityTransferOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityTransferOrder_findPageForManage = (pojo, args) => request({
    url: 'commodityTransferOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityTransferOrder_findPageListForManage = (pojo, args) => request({
    url: 'commodityTransferOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityTransferOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'commodityTransferOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityTransferOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'commodityTransferOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const commodityTransferOrder_saveIntoDraft = (pojo, args) => request({
    url: 'commodityTransferOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityTransferOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'commodityTransferOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityTransferOrder_update = (pojo, args) => request({
    url: 'commodityTransferOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityTransferOrder_updateAndSubmit = (pojo, args) => request({
    url: 'commodityTransferOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityTransferOrder_submitById = (id, args) => request({
    url: 'commodityTransferOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityTransferOrder_deleteById = (id, args) => request({
    url: 'commodityTransferOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityTransferOrder_approval = (pojo, args) => request({
    url: 'commodityTransferOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityTransferOrder_findById = (id, args) => request({
    url: 'commodityTransferOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodityTransferOrder_findVoById = (id, args) => request({
    url: 'commodityTransferOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commodityTransferOrder.js